import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, BookOpen, AlertTriangle, Bot, FolderKanban, ClipboardCheck } from 'lucide-react';
export function ProfessionalComparison() {
  const comparisons = [{
    situation: 'Preparar clases para la semana',
    without: 'Tardás horas buscando y adaptando',
    with: '120 secuencias listas para copiar y usar mañana mismo'
  }, {
    situation: 'Resolver problemas técnicos',
    without: 'Ejercicios genéricos sin contexto argentino',
    with: '100 situaciones problemáticas con minería argentina real'
  }, {
    situation: 'Usar IA para generar material',
    without: 'No sabés cómo aplicarla a minería',
    with: '80+ prompts listos para generar evaluaciones y actividades en minutos'
  }, {
    situation: 'Proyectos de trimestre',
    without: 'Proyectos básicos sin guía del docente',
    with: '15 proyectos ABP completos con guía, cronograma y rúbrica'
  }, {
    situation: 'Evaluar con criterios claros',
    without: 'Rúbricas genéricas',
    with: '25 rúbricas profesionales específicas para cada tarea minera'
  }, {
    situation: 'Posicionarte como docente de vanguardia',
    without: 'Tu material es el mismo que el de todos',
    with: 'Enseñás lo que ningún libro de texto del sector tiene todavía'
  }];
  const modules = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-247" />,
    title: '120 Secuencias Didácticas Listas para Usar',
    color: 'text-forest',
    bgColor: 'bg-forest/10',
    items: '20 secuencias por tomo, en tres niveles (Base, Intermedio, Avanzado), cada una con objetivo, estrategia, descripción paso a paso, materiales y evaluación. Listas para copiar, pegar y aplicar mañana mismo.'
  }, {
    icon: <AlertTriangle className="w-6 h-6" data-id="element-248" />,
    title: '100 Situaciones Problemáticas Contextualizadas',
    color: 'text-earth',
    bgColor: 'bg-earth/10',
    items: 'Casos técnicos reales ambientados en la minería argentina: el geólogo que encontró litio en la Puna, el director de minería de Jujuy que debe aprobar un proyecto, la planta que no llega al P80, el precio del litio que cayó 40%. Con datos, restricciones y respuesta orientativa para el docente.'
  }, {
    icon: <Bot className="w-6 h-6" data-id="element-249" />,
    title: '80+ Prompts de IA para la Enseñanza de Minería',
    color: 'text-gold-dark',
    bgColor: 'bg-gold/10',
    items: 'Prompts listos para generar evaluaciones personalizadas, situaciones problemáticas adaptadas a tu provincia, actividades diferenciadas por tres niveles, secuencias para el día siguiente y feedback por perfil de alumno. Usando ChatGPT, Claude, Gemini o cualquier IA gratuita.'
  }, {
    icon: <FolderKanban className="w-6 h-6" data-id="element-250" />,
    title: '15 Proyectos ABP Completos con Guía del Docente',
    color: 'text-forest',
    bgColor: 'bg-forest/10',
    items: 'Cada proyecto incluye guía completa del docente con posibles obstáculos y soluciones, guía del alumno con entregables y cronograma, y rúbrica específica. Desde "La Mina Sustentable del Siglo XXI" hasta "El Litio que el Mundo Necesita".'
  }];
  return <section className="py-20 bg-white" data-id="element-251">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-252">
        <div className="text-center mb-12" data-id="element-253">
          <h2 className="md:text-4xl font-extrabold text-forest-dark mb-4 text-[18px]" data-id="element-254">
            🎯 ¿QUÉ AGREGA EL UPSELL PREMIUM?
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="mb-16 overflow-x-auto pb-4" data-id="element-255">
          <div className="min-w-[800px]" data-id="element-256">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-257">
              <div className="font-bold text-muted uppercase text-sm tracking-wider" data-id="element-258">
                Situación
              </div>
              <div className="font-bold text-red-600 uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-259">
                <X className="w-4 h-4" data-id="element-260" /> Sin Upsell Premium
              </div>
              <div className="font-bold text-forest uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-261">
                <Check className="w-4 h-4" data-id="element-262" /> Con Upsell Premium
              </div>
            </div>

            <div className="space-y-3" data-id="element-263">
              {comparisons.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-sand/30 rounded-xl p-4 items-center border border-sand" data-id="element-264">
                  <div className="font-medium text-forest-dark" data-id="element-265">
                    {row.situation}
                  </div>
                  <div className="text-muted text-sm" data-id="element-266">{row.without}</div>
                  <div className="text-forest-dark font-medium text-sm bg-forest/10 p-2 rounded-lg border border-forest/30" data-id="element-267">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-muted mt-4 md:hidden" data-id="element-268">
            ← Scroll to see full table →
          </p>
        </div>

        {/* Modules Grid */}
        <div className="bg-base rounded-3xl p-8 md:p-12 text-forest-dark shadow-xl" data-id="element-269">
          <h3 className="font-bold mb-8 flex items-center gap-3 text-[16px]" data-id="element-270">
            <span className="bg-forest text-white p-1 rounded-full" data-id="element-271">
              <Check className="w-5 h-5" data-id="element-272" />
            </span>
            🚀 ¿QUÉ INCLUYE EL UPSELL PREMIUM?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-273">
            {modules.map((mod, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white rounded-2xl p-6 border border-sand" data-id="element-274">
                <div className="flex items-center gap-3 mb-4" data-id="element-275">
                  <div className={`p-2 rounded-lg ${mod.bgColor} ${mod.color}`} data-id="element-276">
                    {mod.icon}
                  </div>
                  <h4 className="font-bold text-lg" data-id="element-277">{mod.title}</h4>
                </div>
                <p className="text-muted text-sm leading-relaxed" data-id="element-278">
                  {mod.items}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}